import {
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { SavedBrushedObject } from "@/types";

interface Props {
  open: boolean;
  close: () => void;
  brushes: SavedBrushedObject[];
  handleSelect: (id: number) => void;
  deleteBrush: (id: number) => void;
}

export const LoadBrushModal = (props: Props) => {
  return (
    <Dialog
      open={props.open}
      scroll={"paper"}
      aria-labelledby="form-dialog-title"
      style={{ zIndex: 1000000000 }}
    >
      <DialogTitle id="form-dialog-title">Select a Brush</DialogTitle>
      <DialogContent>
        <DialogContentText>Load a Saved Brush!</DialogContentText>
        {props.brushes.map((i) => {
          return (
            <ButtonGroup
              variant="outlined"
              aria-label="text button group"
              style={{ margin: "5px" }}
              key={i.id}
            >
              <Button
                onClick={() => {
                  props.handleSelect(i.id);
                  props.close();
                }}
              >
                {" "}
                {i.name}
              </Button>
              <Button
                onClick={() => {
                  props.deleteBrush(i.id);
                }}
              >
                X
              </Button>
            </ButtonGroup>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.close} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
